import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MessageCircle } from 'lucide-react';
import DreamlandNavbar from '../components/dreamland/Navbar';
import DreamlandHeroSlider from '../components/dreamland/HeroSlider';
import HeroSection from '@/components/dreamland/HeroSection';
import { ServicesSection, StatsSection, TestimonialsSection, ContactSection } from '../components/dreamland/Sections';
import { AboutSection, FoodSection, RoomsSection, EventsSection, GallerySection } from '../components/dreamland/ContentSections';
import DreamlandFooter from '../components/dreamland/Footer';
import { contactInfo } from '../data/dreamlandData';

import OtherPropertiesSection from '../components/dreamland/OtherPropertiesSection';

// Add it after <TestimonialsSection /> and before <ContactSection />

import { Helmet } from "react-helmet";



const DreamlandPage = () => {
  const navigate = useNavigate();

  return (
    <div className="dreamland-page" style={{ minHeight: '100vh', background: '#FDFBF7' }}>
      {/* Back Button */}
      {/* <button className="back-btn" onClick={() => navigate('/')}>
        <ArrowLeft size={14} />
        All Hotels
      </button> */}

      <DreamlandNavbar />  
      <DreamlandHeroSlider />
    {/* <HeroSection/> */}
      {/* <OtherPropertiesSection /> */}
                <RoomsSection />
      {/* <ServicesSection /> */}

      <AboutSection />
      <FoodSection />
  
      <StatsSection />
      <EventsSection />
      <GallerySection />
      <TestimonialsSection />
      <ContactSection />
      <DreamlandFooter />

      {/* WhatsApp Float Button */}
      {/* <a
        href={`https://api.whatsapp.com/send?phone=${contactInfo.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        title="Chat with us on WhatsApp"
      >
        <MessageCircle size={26} />
      </a> */}

    

    </div>
  );
};

export default DreamlandPage;
